module.exports = __webpack_public_path__ + "img/MetalJacket.bbe77bb1.gif";